import { render, staticRenderFns } from "./STBConfigList.vue?vue&type=template&id=12120490&scoped=true"
import script from "./STBConfigList.vue?vue&type=script&lang=js"
export * from "./STBConfigList.vue?vue&type=script&lang=js"
import style0 from "./STBConfigList.vue?vue&type=style&index=0&id=12120490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12120490",
  null
  
)

export default component.exports